import { all, call, put, spawn } from 'redux-saga/effects';

import graphqlQuery from '../../graphql';
import { contentUpdate } from './actions';
import { selectQueryForPage } from '../../graphql/selectors';

export function* fetchContent() {
  try {
    const url = api_config.contentStackUrl;
    let { query, variables } = selectQueryForPage({ contentKey: 'plus' });
    const json1 = yield call(graphqlQuery, { url, query, variables });
    ({ query, variables } = selectQueryForPage({ contentKey: 'plus2' }));
    const json2 = yield call(graphqlQuery, { url, query, variables });
    ({ query, variables } = selectQueryForPage({ contentKey: 'plus3' }));
    const json3 = yield call(graphqlQuery, { url, query, variables });
    const json = { ...json1, ...json2, ...json3 };
    yield put(contentUpdate(json));
  } catch (e) {
    // silent catch
  }
}

export default function* root() {
  yield all([
    spawn(fetchContent)
  ]);
}
